import { Name, YAMLContent } from "../../yaml-content";
import RequestTypeComponent from "./api_reference/request_type_component";
import SchemaElementComponent from "./api_reference/schema_element_component";
import React from "react";

type Props = {
  yaml: YAMLContent;
};
const InnerApiReference = ({ yaml }: Props) => {
  /** Looks for untagged endpoint and adds the "other" section if needed */
  let otherSection = false;
   // Check if any endpoint is untagged
   yaml.paths.forEach((item) => {
    if (
      (item.get && item.get.tags == null) ||
      (item.delete && item.delete.tags == null) ||
      (item.patch && item.patch.tags == null) ||
      (item.post && item.post.tags == null) ||
      (item.put && item.put.tags == null)
    ) {
      otherSection = true;
    }
  });

  // Add the "Others" tag only if it doesn't already exist
  if (otherSection) {
    const hasOthersTag = yaml.tags.some((tag) => tag.name === Name.Others);
    if (!hasOthersTag) {
      // Avoid mutating the original yaml object
      yaml.tags = [...yaml.tags, { name: Name.Others }];
    }
  }

  return (
    <section>
      <div className="ulist">
        <ul>
          {yaml.tags.map((item, index) => {
            return (
              <li key={index}>
                <p className="mb-1">
                  <a href={`#_${item.name.toLowerCase()}`}>{item.name}</a>
                </p>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="relative">
        <div
          className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
          id="_endpoints"
        ></div>
        <h2 className="!pt-4 !text-3xl "
          data-adoc-section-id="_endpoints"
          data-adoc-section-title="Endpoints"
        >
          Endpoints
          <a href="#_endpoints">
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 24 24"
              height="22"
              width="22"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path>
            </svg>
          </a>
        </h2>
      </div>

      {yaml.tags.map((tag, index) => {
        return (
          <div className="relative" key={index}>
            <div
              className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
              id={`_${tag.name.toLowerCase()}`}
            ></div>
            <h3 className="!pt-4 !text-xl"
              data-adoc-section-id={`_${tag.name.toLowerCase()}`}
              data-adoc-section-title={tag.name}
            >
              {tag.name}
              <a href={`#_${tag.name.toLowerCase()}`}>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  height="22"
                  width="22"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path>
                </svg>
              </a>
            </h3>

            {yaml.paths.map((item, index) => {
              const hasGet = item.get && (item.get.tags?.indexOf(tag.name) > -1 || (item.get.tags == null && tag.name == Name.Others));
              const hasPost = item.post && (item.post.tags?.indexOf(tag.name) > -1 || (item.post.tags == null && tag.name == Name.Others));
              const hasPatch = item.patch && (item.patch.tags?.indexOf(tag.name) > -1 || (item.patch.tags == null && tag.name == Name.Others));
              const hasPut = item.put && (item.put.tags?.indexOf(tag.name) > -1 || (item.put.tags == null && tag.name == Name.Others));
              const hasDelete = item.delete && (item.delete.tags?.indexOf(tag.name) > -1 || (item.delete.tags == null && tag.name == Name.Others));
              if (hasGet || hasPost || hasPatch || hasPut || hasDelete) {
                return (
                  <div key={index}>
                    {((item.get && item.get.tags?.indexOf(tag.name) > -1) ||
                      (item.get &&
                        item.get.tags == null &&
                        tag.name == Name.Others)) && (
                        <div>
                          <RequestTypeComponent
                            components={yaml.components}
                            method="Get"
                            path={item.name}
                            request={item.get}
                            item={item}
                          />
                        </div>
                      )}
                    {((item.post && item.post.tags?.indexOf(tag.name) > -1) ||
                      (item.post &&
                        item.post.tags == null &&
                        tag.name == Name.Others)) && (
                        <div>
                          <RequestTypeComponent
                            components={yaml.components}
                            method="Post"
                            path={item.name}
                            request={item.post}
                            item={item}
                          />
                        </div>
                      )}
                    {((item.patch && item.patch.tags?.indexOf(tag.name) > -1) ||
                      (item.patch &&
                        item.patch.tags == null &&
                        tag.name == Name.Others)) && (
                        <div>
                          <RequestTypeComponent
                            components={yaml.components}
                            method="Patch"
                            path={item.name}
                            request={item.patch}
                            item={item}
                          />
                        </div>
                      )}
                    {((item.put && item.put.tags?.indexOf(tag.name) > -1) ||
                      (item.put &&
                        item.put.tags == null &&
                        tag.name == Name.Others)) && (
                        <div>
                          <RequestTypeComponent
                            components={yaml.components}
                            method="Put"
                            path={item.name}
                            request={item.put}
                            item={item}
                          />
                        </div>
                      )}
                    {((item.delete && item.delete.tags?.indexOf(tag.name) > -1) ||
                      (item.delete &&
                        item.delete.tags == null &&
                        tag.name == Name.Others)) && (
                        <div>
                          <RequestTypeComponent
                            components={yaml.components}
                            method="Delete"
                            path={item.name}
                            request={item.delete}
                            item={item}
                          />
                        </div>
                      )}
                  </div>
                );
              }
              return null;
            })}
          </div>
        );
      })}

      {yaml.components.schemas && yaml.components.schemas?.length > 0 && (
        <div className="relative">
          <div
            className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
            id="_endpoints"
          ></div>
          <h2 data-adoc-section-id="_models" data-adoc-section-title="Models" className="!pt-4 !text-3xl">
            Models
            <a href="#_models">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 24 24"
                height="22"
                width="22"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path>
              </svg>
            </a>
          </h2>
        </div>
      )}
      <div className="flex flex-col">
        {yaml.components.schemas?.map((item, index) => {
          return (
            <div key={index}>
              <SchemaElementComponent
                schemaType={item}
                componentSchemas={yaml.components.schemas}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};
export default InnerApiReference;
